import { LogOut, House, ChevronDown, ChevronUp } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { useState, useEffect, useRef } from "react";

import { useAuth } from '../contexts/AuthContext';
import { ROUTES_CONFIG } from "../config/routes-permissions";

import logo from "../assets/images/logo.png";
import profile from "../assets/images/profile.svg";

const SubMenu = () => {
  const { logout } = useAuth();
    return (
      <div className="absolute mt-2 right-4 bg-lightGray py-6 px-6 border border-black rounded-md flex flex-col" style={{zIndex: "100"}}>
        <Link to="/profile" className="py-1.5 px-4 hover:bg-stone-200">Personal Info</Link>
        <button className="py-1.5 px-4 hover:bg-stone-200 text-start" onClick={() => logout()}>Logout</button>
      </div>
    );
};

const NavBar = function () {
    // const { user, logout } = useAuth();
    const location = useLocation();
    const [menuIsOpen, setMenuIsOpen] = useState(false);
    const navBarRef = useRef(null);

    // 全局點擊事件處理程序，用於關閉子菜單
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (navBarRef.current && !navBarRef.current.contains(event.target)) {
                // 點擊的是導航欄外部，關閉所有子菜單
                setMenuIsOpen(false);
            }
        };
        
        // 添加全局點擊事件監聽器
        document.addEventListener('mousedown', handleClickOutside);
        
        // 清理函數
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <nav className="bg-mediumGray w-full px-6 py-2.5 fixed z-50" ref={navBarRef}>
          <div className="flex justify-between">
            <Link to="/">
              <img src={logo} alt="BioDND"></img>
            </Link>
            <button className="ml-4" onClick={() => setMenuIsOpen(prev => !prev)}>
                <img src={profile} alt="profile menu" className="w-[43px] h-[43px]"></img>
                {menuIsOpen && (<SubMenu />)}
            </button>
          </div>
        </nav>
    )

}

export default NavBar;